module.exports = __webpack_public_path__ + "05a06a3094f3e9da10c8f402533d91d0.jpg";